export default __webpack_public_path__ + "Emerson_Logo_AFSC-01-1926x567.87b062bca5fe1cf38e63.png";